/**
 * The well-known Angular route path for the SSOID login page
 */
export const SSOID_LOGIN_PATH = 'login-email';
